/* 案件詳細（職員）アクションボタン */
import React from 'react';
// import ReturnMenuButton from '../molecules/ReturnMenuButton';

// interface Props {
//   is_staff: boolean;
//   is_on_change: boolean;
// }

// const StaffReceptionActionButtons: React.FC<Props> = ({ is_staff, is_on_change }) => {
const StaffReceptionActionButtons: React.FC = () => {
  // 戻るボタン押下時のイベント
  const handleOnClickReturn = () => {
    location.href = `${location.origin}${process.env.MIX_MOCK_URL}/staff/list`;
  };

  return (
    <>
      <div className="staff-reception-action-buttons">
        <div className="d-flex justify-content-around">
          <button
            type="button"
            className="btn btn-outline-success w-160px"
            onClick={handleOnClickReturn}
          >
            案件一覧へ戻る
          </button>
          <button
            type="button"
            className="btn btn-outline-success w-160px position-relative"
            data-toggle="modal"
            data-target="#download"
          >
            ダウンロード{' '}
            <span id="downloaded" style={{ display: 'none' }}>
              済
            </span>
          </button>
        </div>
      </div>
    </>
  );
};

export default StaffReceptionActionButtons;
